import script from "./Tool.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tool.vue?vue&type=script&setup=true&lang=ts"

import "./Tool.vue?vue&type=style&index=0&id=4aada13f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aada13f"]])

export default __exports__